import React, { useCallback } from 'react';
import PaymentSuccess from '../components/checkout/payment/PaymentSuccess';
import OrderSummaryBox from '../components/checkout/OrderSummaryBox';
import Header from '../components/checkout/Header';

const formatDate = (date: Date) => {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

const CheckoutProSuccessPage: React.FC = () => {
  const now = new Date();
  const nextYear = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
  const logo = useCallback(() => (
    <img src="https://hermes.dio.me/assets/products/full/pro-lifetime.svg" alt="DIO Pro Vitalício" className="w-64 h-auto mx-auto" />
  ), []);

  return (
    <div className="min-h-screen bg-[#F7F9FB] flex flex-col justify-start">
      <Header defaultLogoUrl="https://hermes.dio.me/assets/diome/logo-full.svg" />
      <div className="flex justify-center items-start py-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 w-full max-w-6xl px-4">
          <div className="lg:col-span-7">
            <PaymentSuccess 
              title="Parabéns! Agora você é DIO PRO Vitalício"
              message="Em breve, você terá acesso para sempre a bootcamps, formações, projetos e cursos para dar o próximo passo na sua carreira em tecnologia."
              paymentMethod="PIX"
            />
          </div>
          <div className="lg:col-span-5">
            <OrderSummaryBox
            logo={logo}
            planName="Vitalício"
            productPrice="R$ 1198,80"
              discount="-R$ 780,00"
              total="R$ 418,80"
            installment="Pago"
            isSuccessPage={true}
            status="Pago"
            startDate={new Date().toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' })}
            endDate={formatDate(nextYear)}
            features={[
              "Acesso ilimitado em bootcamps e os próximos lançamentos.",
              "Acesso a TODOS os cursos DIO PRO e próximos lançamentos nas carreiras front-end, back-end, mobile, data, inteligência artificial, games, cloud e DevOps.",
              "Acesso a TODAS as formações profissionais exclusivas do DIO PRO para você se preparar e conquistar as melhores vagas do mercado tech.",
              "+200 projetos para você ganhar experiência prática e os próximos lançamentos.",
              "Certificado de conclusão.",
              "Acesso ao AI Job Hunter com 5.000 créditos, indicação diária de vagas com score de compatibilidade e feedback personalizado por vaga.",
              "Acesso ao Agente de IA que adapta seu currículo ao ATS, gera o Raio-X de cada vaga e mostra o passo a passo de evolução para chegar preparado na entrevista.",
              "Acesso ao Preparatório de entrevista que reproduz uma situação real com recrutadores e feedback personalizado sobre o seu desempenho na entrevista.",
              "Cancelamento grátis em 7 dias."
            ]}
          />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutProSuccessPage;
